import React, { useEffect, useLayoutEffect } from 'react';
import { Image, View, Text, TouchableOpacity } from 'react-native';
import { MaterialIcons } from "@expo/vector-icons";
import * as ScreenOrientation from 'expo-screen-orientation';
import { useIsFocused } from '@react-navigation/native';
import { FormattedMessage } from 'react-intl';

import HeaderDefault from '../../components/HeaderDefault';

import styles from './styles';

const PaymentMethodPay = ({ navigation }) => {
  const isFocused = useIsFocused();

  // useLayoutEffect(() => {
  //   // console.log(isFocused)
  //     setTimeout(async () => {
  //       // await ScreenOrientation.lockAsync(ScreenOrientation.Orientation.PORTRAIT_UP);
  //       const a = await ScreenOrientation.getOrientationAsync();
  //        console.log('a',a)
  //       if(a){
  //         await ScreenOrientation.lockAsync(ScreenOrientation.OrientationLock.PORTRAIT_UP);
  //       }
  //       // await ScreenOrientation.lockAsync(ScreenOrientation.Orientation.PORTRAIT_UP);
  //     }, 10);
  // }, [isFocused]);

  return (
    <>
      <HeaderDefault title={<FormattedMessage id='paymentMethodPay.headerPagar'/>} />

      <View style={styles.content}>
        <View style={styles.contentList}>
          <TouchableOpacity style={styles.contentItemList} onPress={() => navigation.navigate("QrCodePay")}>
            <Image style={[styles.iconInfo, { width: 20, height: 20, marginTop: 5, marginRight: 8 }]} source={require('../../../assets/imgs/qrcode.png')} />
            <View>
              <Text style={styles.titleItemList}><FormattedMessage id='paymentMethodPay.txtQrCode'/></Text>
              <Text style={[styles.descriptionItemList, { width: 280 }]}><FormattedMessage id='paymentMethodPay.txtPagueLeitorQrCode'/></Text>
            </View>
            <MaterialIcons
              name="keyboard-arrow-right"
              size={25}
              color="#2C2C2E"
              style={{ alignSelf: 'center' }}
            />
          </TouchableOpacity>
          <View style={styles.hr} />

          <TouchableOpacity style={styles.contentItemList} onPress={() => navigation.navigate("BarCodePay")}>
            <Image style={[styles.iconInfo, { width: 28, height: 20, marginTop: 5 }]} source={require('../../../assets/imgs/bankSlip.png')} />
            <View>
              <Text style={styles.titleItemList}><FormattedMessage id='paymentMethodPay.txtCodigoBarras'/></Text>
              <Text style={[styles.descriptionItemList, { width: 280 }]}><FormattedMessage id='paymentMethodPay.txtGeraBoletoCompraAtivos'/></Text>
            </View>
            <MaterialIcons
              name="keyboard-arrow-right"
              size={25}
              color="#2C2C2E"
              style={{ alignSelf: 'center' }}
            />
          </TouchableOpacity>
          <View style={styles.hr} />
        </View>
      </View>
    </>
  );
}

export default PaymentMethodPay;